<template>
  <div>
    <div class="left-panel">
        <div class="card">
            <div class="header">
                <div class="title">
                    <div class="decorate"></div><div> 气象信息</div>
                </div>
                <div class="extra">
                    <a-icon class="weatherDiv" type="right"  @click="$router.push('/weather')"/>
                </div>
            </div>
            <div class="body">
                <Weather />
            </div>
        </div>

      <div class="card">
        <div class="header">
            <div class="title">
              <div class="decorate"></div><div>管道分析</div>
            </div>
        </div>
        <div class="body">
            <span style="color: #fff;">管长分析</span>
            <BaseInfo :sewageLength="sewageLength" :rainLength="rainLength" :sewageLengthList="sewageLengthList" :rainLengthList="rainLengthList"/>
<!--            管网设施分析-->
<!--            <WellInfo :drainList="drainList" :wellList="wellList" />-->
            <div class="pipe-diameter-pump">
              <PipeDiameterAnalysis/>
              <PipePump/>
            </div>
<!--            <PipeDiameter :sewageDiameter="sewageDiameter" :rainDiameter="rainDiameter" />-->
        </div>
      </div>

<!--      <div class="card">-->
<!--        <div class="header">-->
<!--          <div class="title">-->
<!--              <div class="decorate"></div><div>管网设施分析</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="body">-->
<!--            管网设施分析-->
<!--          <WellInfo :drainList="drainList" :wellList="wellList" />-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <Map :alertText="alertText" />
    <div class="right-panel">
      <div class="card">
        <div class="header">
            <div class="title">
              <div class="decorate"></div><div>设备状态</div>
            </div>
        </div>
        <div class="body">
          <Status />
        </div>
      </div>
      <div class="card">
        <div class="header">
            <div class="title">
              <div class="decorate"></div><div>综合养护</div>
            </div>
        </div>
        <div class="body">
          <Task />
        </div>
      </div>
      <div class="card">
        <div class="header">
          <div class="title">
              <div class="decorate"></div><div>最新报警</div>
          </div>
          <div class="extra">
            <AlertList @select="select" />
          </div>
        </div>
        <div class="body">
          <AlertComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BaseInfo from "./components/base-info.vue";
import PipeDiameterAnalysis from "./components/pipe-diameter-analysis.vue";
import PipePump from "./components/pipe-pump.vue";
// import WellInfo from "./components/well-info.vue";
import Map from "./components/map";
import Weather from "./components/weather.vue";
import Task from "./components/task.vue";
import Status from "./components/status.vue";
import AlertComponent from "./components/alert.vue";
import AlertList from "./components/alert-list.vue";

import request from "@/api/request";

export default {
  components: {
    BaseInfo,
    PipeDiameterAnalysis,
    PipePump,
    // WellInfo,
    Task,
    Status,
    AlertComponent,
    AlertList,
    Map,

    Weather,
  },

  data() {
    return {
      alertText: {},

      lengthList: [],

      // 管道长度
      sewageLength: 0,
      rainLength: 0,

      // 主管/支管长度
      sewageLengthList: [],
      rainLengthList: [],

      // 管径长度
      sewageDiameter: {},
      rainDiameter: {},

      drainList: [],
      wellList: [],
    };
  },

  mounted() {
    request({
      url: "/model-analysis/pipe/stat",
    }).then((res) => {
      const { pipeMap = {}, drainMap = {}, wellMap = {} } = res || {};

      const { rain = {}, sewage = {} } = pipeMap;

      this.sewageLength = sewage?.model?.length || 0;
      this.rainLength = rain?.model?.length || 0;

      this.sewageLengthList = [
        {
          name: "主管",
          value: sewage?.model?.thickLength || 0,
        },
        {
          name: "支管",
          value: sewage?.model?.thinLength || 0,
        },
      ];

      this.rainLengthList = [
        {
          name: "主管",
          value: rain?.model?.thickLength || 0,
        },
        {
          name: "支管",
          value: rain?.model?.thinLength || 0,
        },
      ];

      if (sewage.diameter && typeof sewage.diameter === "object") {
        this.sewageDiameter = sewage.diameter;
      }
      if (rain.diameter && typeof rain.diameter === "object") {
        this.rainDiameter = rain.diameter;
      }

      this.drainList = Object.keys(drainMap).map((key) => ({
        name: key,
        value: drainMap[key],
      }));
      this.wellList = Object.keys(wellMap).map((key) => ({
        name: key,
        value: wellMap[key],
      }));
    });
  },

  methods: {
    select(text) {
      this.alertText = text;
    },
  },
};
</script>

<style lang="less" scoped>
.left-panel {
  position: fixed;
  left: 1vw;
  width: 25vw;
  z-index: 1;
}

.right-panel {
  position: fixed;
  right: 1vw;
  width: 25vw;
  z-index: 1;
}

.card {
  background:var(--card-color);
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
  border-radius: 10px;

  .pipe-diameter-pump{
    display: flex;
    justify-content: space-between;
  }


  .decorate{
    margin:0 10px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-bottom: 5px solid #00ff96;
    position: relative;
    top: -5px;
  }
  .decorate:after {
    content: '';
    position: absolute;
    left: -5px;
    top: 5px;
    width: 0;
    height: 0;
    border: 5px solid transparent;
    border-top: 5px solid #00ff96;
  }

  & > .header {
    margin-top:10px;
    background: url("../../assets/dashboard/cardTitleBg.png")  no-repeat;
    background-size: 100%;
    padding:0 15px;
    color: #fff;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    line-height: 4vh;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .title{
    display:flex;
    justify-content: center;
    align-items: center;
  }

  .body {
    padding: 1.4vh 1vw;
  }

  .extra{
    display: flex;
    align-items: center;
  }

}

</style>